import $ from 'jquery';
import Modal from 'bootstrap/js/dist/modal';

export default {

    targeted_tr_index: -1,

    init() {
        //show default columns (first because it's the main blocking done on rendering)
        this.showDefaultColumns();

        // count the selected rows
        this.updateSelectedRowCount();

        // set active rows
        $("td.sonata-ba-list-field-batch input[type='checkbox']:checked").each((i,e) => {
            $(e).parents('tr').addClass('table-active');
        });

        // select all on page
        $('#list_batch_checkbox').click((event, element) => {
            $(event.target).parents('table').find("td input[type='checkbox']").prop('checked', $(event.target).is(':checked')).trigger('change');
            this.updateSelectedRowCount();
        });

        // listen for specific row select
        $("td.sonata-ba-list-field-batch input[type='checkbox']").change((event) => {
            $(event.target).parents('tr').toggleClass('table-active', $(event.target).is(':checked'));
            this.updateSelectedRowCount();
        });

        // setup a timer (to diff between single/double click) and a selector for the rows
        let timer, $rows = $("table.sonata-ba-list tr:not(.sonata-ba-list-field-header)");

        // listen for click (select row) or shift click (select all rows in between)
        $rows.on('click', event => {

            // register as single click, behind a timer to allow xor double click detection
            if (event.detail === 1) {
                timer = setTimeout(() => {
                    if( $(event.target).is('td') || $(event.target).is('input') )
                    {
                        $(event.target)
                            .parent('tr')
                            .find("td.sonata-ba-list-field-batch input[type='checkbox']")
                            .prop( "checked", function( i, val ) {
                                return !val;
                            })
                            .trigger('change');

                        if (event.shiftKey && this.targeted_tr_index != -1 )
                        {
                            // deselect
                            window.getSelection().removeAllRanges();

                            var current = $(event.target).parents('tr').prevAll().length;
                            var trs = $(event.target).parents('tbody').children('tr');

                            if( current < this.targeted_tr_index )
                            {
                                while( current < this.targeted_tr_index + 1 )
                                {
                                    $(trs.get(current))
                                        .find("td.sonata-ba-list-field-batch input[type='checkbox']")
                                        .prop( "checked", true)
                                        .trigger('change');
                                    current++;
                                }
                            } else {
                                while( current > this.targeted_tr_index - 1 )
                                {
                                    $(trs.get(current))
                                        .find("td.sonata-ba-list-field-batch input[type='checkbox']")
                                        .prop( "checked", true)
                                        .trigger('change');
                                    current--;
                                }
                            }
                        }
                        this.targeted_tr_index = $(event.target).parents('tr').prevAll().length;
                    }

                    this.updateSelectedRowCount();
                }, 200);
            }
        });

        // listen for double click (trigger first non-destructive action)
        $rows.on('dblclick', event => {
            clearTimeout(timer);
            if($(event.target).is('td')) {
                $(event.target)
                    .parents('tr')
                    .children('td.sonata-ba-list-field-actions')
                    .find('i')
                    .each((i,e) => {
                        if($(e).is('.fa-search') || $(e).is('.fa-edit')) {
                            $(e).parent('a').get(0).click();
                            return false;
                        }
                    })
            }
        });

        // listen for changes in visible columns
        $('.edit_columns input').on('change', () => { this.updateUserColumnSelection(); })

        // handle inverse defaults
        if($('section.content-header > div').hasClass('container-full-width')) {
            $('#list-expand').addClass('d-none');
            $('#list-compress').removeClass('d-none');
        }

        // listen to widescreen toggle - expand
        $('#list-expand').click(()=>{
            $('#list-expand').addClass('d-none');
            $('#list-compress').removeClass('d-none');

            $('section.content-header > div.container')
                .addClass('container-fluid container-full-width')
                .removeClass('container');

            $('section.content-body > div.container')
                .addClass('container-fluid container-full-width')
                .removeClass('container');

            this.updateUserListExpansion(1);
        });

        // listen to widescreen toggle - compress
        $('#list-compress').click(()=>{
            $('#list-expand').removeClass('d-none');
            $('#list-compress').addClass('d-none');

            $('section.content-header > div.container-fluid')
                .removeClass('container-fluid container-full-width')
                .addClass('container');

            $('section.content-body > div.container-fluid')
                .removeClass('container-fluid container-full-width')
                .addClass('container');

            this.updateUserListExpansion(0);
        });

        // listen for batch actions
        $('form[name="batch"]').on('submit', function(e) {

            // get the elements
            var withSelectedBar     = $(this).find('.with-selected-bar');
            var withSelectedStatus  = withSelectedBar.find('.with-selected-status');
            var nothingSelected     = withSelectedBar.find('.nothing-selected');
            var withSelected        = withSelectedBar.find('.with-selected');
            var submitSelected      = withSelectedBar.find('button[type=submit]');

            // the button had received a disabled prop from Admin.js, remove it:
            setTimeout(function() {
                submitSelected.prop('disabled', false);
            }, 10);

            // count the selected rows
            if( $(this).serialize().indexOf("idx") < 0 )
            {
                withSelectedStatus.addClass('bg-danger');
                nothingSelected.removeClass('d-none');
                withSelected.addClass('d-none');
                e.preventDefault();
                return false;
            } else {
                withSelectedStatus.removeClass('bg-danger');
                nothingSelected.addClass('d-none');
                withSelected.removeClass('d-none');
            }

            //find the current option and check if it should open in a modal
            var hasModal = $(this).find('select[name="action"] option:selected').data('modal');
            if (typeof hasModal !== typeof undefined && hasModal !== false) {
                e.preventDefault();

                var modalElement = $('#default-modal');

                // don't show if the modal is already shown (shouldn't happen)
                if(modalElement.hasClass("show")) {
                    return false;
                }

                // make the call
                $.ajax({
                    url: $(this).attr('action'),
                    method: 'POST',
                    data: $(this).serialize(),
                    success: ( responseText ) => {
                        modalElement.html(responseText);
                        let modal = new Modal(modalElement, {});
                        modal.show();
                    }
                });

                return false;
            }
        });

        return this;
    },

    /**
     * Generate CSS showing known columns in list views
     */
    showDefaultColumns()
    {
        var column_style_th = 'table.sonata-ba-list th:not(:nth-child(1)):not(:nth-child(2)):not(.edit_columns)';
        var column_style_td = 'table.sonata-ba-list td:not(:nth-child(1)):not(:nth-child(2))';

        $('.edit_columns').find('input:checked').each(function(){
            column_style_th += ":not(:nth-child("+$(this).val()+"))";
            column_style_td += ":not(:nth-child("+$(this).val()+"))";
        });

        $('#list_column_style').html( column_style_th + ", " + column_style_td + " {display:none} ");
        $('table.sonata-ba-list th').removeClass('last_visible_header');
        $('table.sonata-ba-list th:visible:last').addClass('last_visible_header');
    },
        
    /**
     * Show a counter for the number of selected rows
     */
    updateSelectedRowCount()
    {
        var selected = $("input[type=checkbox][name='idx[]']:checked").length;
        if(selected > 0 ) {
            $('#batch-selected-count').html("(" + selected + ")");
            this.hideNothingSeleced();
        } else {
            $('#batch-selected-count').html("");

        }
    },

    /**
     * Shows the default counter when rows are selected
     */
    hideNothingSeleced()
    {
        var withSelectedBar     = $('form[name=batch]').find('.with-selected-bar');
        var withSelectedStatus  = withSelectedBar.find('.with-selected-status');
        var nothingSelected     = withSelectedBar.find('.nothing-selected');
        var withSelected        = withSelectedBar.find('.with-selected');

        withSelectedStatus.removeClass('bg-danger');
        nothingSelected.addClass('d-none');
        withSelected.removeClass('d-none');
    },

    /**
     * When a user changes the column selection, update the view and store in User settings
     */
    updateUserColumnSelection()
    {
        //display
        this.showDefaultColumns();
    
        //save settings
        var settings = {
            'list':    Syn.route,
            'columns': []
        };
    
        //push to settings
        $('.edit_columns').find('input:checked').each(function() {
            settings.columns.push($(this).val());
        });
    
        //persist
        $.ajax({
            url:        Syn.generateURL('user_profile_listcolumns'),
            method:     "POST",
            data:       settings,
            dataType:   "json"
        });
    },
    
    /**
     * Post updated user list config to server
     * @param expanded
     */
    updateUserListExpansion(expanded)
    {
        //save settings
        var settings = {
            'list':         Syn.route,
            'expanded':     expanded
        };
    
        //persist
        $.ajax({
            url:        Syn.generateURL('user_profile_listexpansion'),
            method:     "POST",
            data:       settings,
            dataType:   "json"
        });
    },
}
